import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { KeyActionButton } from './KeyActionButton'
import { generatePath } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { DOC_PATH } from 'paths'

export interface MarkAsReadButtonProps {
  request: InformalFeedbackRequest
}

export const MarkViewerAsReadButton = ({ request }: MarkAsReadButtonProps) => {
  const history = useHistory()
  const { article, layer } = request

  return (
    <KeyActionButton
      reviewType={request.type}
      label={'Mark As Read'}
      onPress={() =>
        history.push({
          pathname: generatePath(DOC_PATH, { slug: article.slug }),
          search: !layer.is_main ? `layer=${layer.id}` : '',
        })
      }
    />
  )
}
